import { render, staticRenderFns } from "./maptenderDetails.vue?vue&type=template&id=be88c904&scoped=true"
import script from "./maptenderDetails.vue?vue&type=script&lang=js"
export * from "./maptenderDetails.vue?vue&type=script&lang=js"
import style0 from "./maptenderDetails.vue?vue&type=style&index=0&id=be88c904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be88c904",
  null
  
)

export default component.exports